import CtflTable from './ctfl-table'
import CtflTableQuery from './ctfl-table.query'

export { CtflTableQuery }

export default CtflTable
